import type {Routes} from "@angular/router";
import {LoginComponent} from "./modules/login/login.component";
import {LayoutComponent} from "./layout/components/layout/layout.component";
import {AuthGuard} from "./shared/auth/auth.guard";
import {DashboardComponent} from "./modules/dashboard/dashboard.component";
import {UserRoutes} from "./modules/user/user.routes";
import {AnimalRoutes} from "./modules/animals/animals.routes";
import {ContactsRoutes} from "./modules/contact/contacts.routes";
import {StatisticsRoutes} from "./modules/statistics/statistics.routes";
import {AnimalShelterRoutes} from "./modules/animal-shelter/animal-shelter.routes";

export const routes: Routes = [
  {path: 'login', component: LoginComponent},
  {
    path: '', component: LayoutComponent, canActivate: [AuthGuard],
    children: [
      {path: '', redirectTo: 'home', pathMatch: 'full'},
      {path: 'home', component: DashboardComponent},
      ...UserRoutes,
      ...AnimalRoutes,
      ...ContactsRoutes,
      ...StatisticsRoutes,
      ...AnimalShelterRoutes
    ]
  },
  {path: '**', redirectTo: 'login', pathMatch: 'full'},
];
